import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import s from "./labReportPdf.module.scss";
import Barcode from "react-barcode";
import qrcode from "../../../images/qr.png";
import CultureReport from "../labReport/editLabReportComponent/cultureReport";
import UrineReport from "../labReport/editLabReportComponent/UrineRMReport";
import StoolReport from "../labReport/editLabReportComponent/StoolRMReport";
import DengueReport from "../labReport/editLabReportComponent/dengueReportPdf";
import DengueRapidReport from "../labReport/editLabReportComponent/dengueRapidTestPdf";
import TyphoidReport from "../labReport/editLabReportComponent/typhoidProfileReport";
import SynovialFluidAnalysisPdf from "./editLabReportComponent/synovialFluidAnalysisPdf";
import PeripheralSmearReport from "./editLabReportComponent/psComments";
import MalariaParasiteICT from "./editLabReportComponent/MalariaParasiteReport";
import SeminalFluidAnalysisPdf from "./editLabReportComponent/SeminalFluidAnalysisPdf";
import FnacReportPdf from "./editLabReportComponent/FnacReportPdf";
import WidalReportPdf from "./editLabReportComponent/WidalReportPdf";
import CBCReport from "./editLabReportComponent/CBCReport";
import { FaArrowLeft, FaWhatsapp, FaMailBulk } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { getPhysicianById } from "../../../store/slices/physicianSlice";
import Modal from "react-bootstrap/Modal";
import {
  sendWhatsappReport,
  sendLabReportMail,
  resetEmailMessage,
  resetWhatsappMessage,
} from "../../../store/slices/labReportSlice";
import html2pdf from "html2pdf.js";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
const LabReportPDF = () => {
  const componentRef = useRef();
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const [mobile, setMobile] = useState("");
  const [showWhatsapp, setShowWhatsapp] = useState(false);
  const [showMobileInput, setShowMobileInput] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const [individualTestPages, setIndividualTestPages] = useState([]);
  const [individualPaginationReady, setIndividualPaginationReady] =
    useState(false);
  const hasIndividualTestPages =
    individualTestPages && individualTestPages.length > 0;

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const {
    labReport,
    whatsappSuccessMessage,
    whatsappErrorMessage,
    emailSuccessMessage,
    emailErrorMessage,
  } = useSelector((state) => state.labReport);
  const activeId =
    sessionStorage.getItem("allReportsId") ||
    sessionStorage.getItem("outSourceToId") ||
    sessionStorage.getItem("outSourceFromId");

  const newLabReport = useMemo(() => {
    return labReport?.find((report) => report._id === activeId) || null;
  }, [labReport, activeId]);
  useEffect(() => {
    if (!newLabReport) return;
  }, [newLabReport]);
  const chunkArray = (array, size) => {
    const result = [];
    if (!array) return result;
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const getStatusStyle = (value, rangeStr) => {
    if (!value || !rangeStr || rangeStr === "N/A") {
      return {
        fontWeight: "normal",
        color: "#000",
      };
    }

    const numValue = parseFloat(value);
    const limits = rangeStr.match(/(\d+(\.\d+)?)/g);

    if (!limits || isNaN(numValue)) {
      return {
        fontWeight: "normal",
        color: "#000",
      };
    }

    const low = parseFloat(limits[0]);
    const high = parseFloat(limits[limits.length - 1]);

    // Bold only when value is greater than the reference range
    if (numValue > high) {
      return {
        fontWeight: "900",
        color: "#000",
      };
    }

    // Normal when within or below the range
    return {
      fontWeight: "normal",
      color: "#000",
    };
  };

  const { standaloneTests, detailedProfiles } = useMemo(() => {
    if (!newLabReport) return { standaloneTests: [], detailedProfiles: [] };
    const allTests = newLabReport.tests || [];
    const profiles = newLabReport.profiles || [];
    const testsInProfiles = new Set();
    profiles.forEach((p) => {
      p.tests?.forEach((t) => {
        testsInProfiles.add(t.testName || t._id);
      });
    });
    const filteredStandalone = allTests.filter(
      (t) => !testsInProfiles.has(t.testName || t._id),
    );
    return { standaloneTests: filteredStandalone, detailedProfiles: profiles };
  }, [newLabReport]);

  const profileSampleTypes = useMemo(() => {
    return [
      ...new Set(
        (newLabReport?.profiles || [])
          .map((profile) => profile.sampleType)
          .filter(Boolean),
      ),
    ];
  }, [newLabReport]);

  const groupIndividualTestsByCategory = useCallback(() => {
    if (!standaloneTests?.length) {
      return [];
    }

    const groups = {};

    standaloneTests.forEach((test) => {
      const categoryName = test?.category?.categoryName?.trim() || "OTHERS";

      if (!groups[categoryName]) {
        groups[categoryName] = [];
      }

      groups[categoryName].push(test);
    });

    return Object.entries(groups).map(([categoryName, tests]) => ({
      categoryName,
      tests,
    }));
  }, [standaloneTests]);

  const createIndividualTestPages = useCallback(() => {
    const groupedCategories = groupIndividualTestsByCategory();

    if (!groupedCategories?.length) {
      setIndividualTestPages([]);
      setIndividualPaginationReady(true);
      return;
    }

    /*
     * ============================================================
     * PAGE SETTINGS
     * ============================================================
     */

    const PAGE_HEIGHT_MM = 297;

    /*
     * Your reportPage:
     *
     * padding-top    = 10mm
     * padding-bottom = 45mm
     *
     * Footer is inside the bottom 45mm area.
     */

    const TOP_PADDING_MM = 10;
    const BOTTOM_PADDING_MM = 45;

    /*
     * PageBaseLayout + patient details + barcode.
     *
     * Keep this conservative.
     */
    const HEADER_HEIGHT_MM = 72;

    /*
     * Extra safety area.
     */
    const SAFETY_MM = 8;

    /*
     * Actual usable area for test content.
     */
    const AVAILABLE_HEIGHT_MM =
      PAGE_HEIGHT_MM -
      TOP_PADDING_MM -
      BOTTOM_PADDING_MM -
      HEADER_HEIGHT_MM -
      SAFETY_MM;

    /*
     * ============================================================
     * ELEMENT HEIGHTS
     * ============================================================
     */

    const CATEGORY_HEIGHT_MM = 7;

    const THEAD_HEIGHT_MM = 8;

    /*
     * Your normal test rows are approximately 8mm.
     */
    const NORMAL_TEST_HEIGHT_MM = 8;

    /*
     * Interpretation blocks are much taller than normal rows.
     *
     * Use conservative values.
     */
    const FBS_INTERPRETATION_MM = 28;

    const PPBS_INTERPRETATION_MM = 32;

    const URIC_ACID_INTERPRETATION_MM = 32;
    const RBS_INTERPRETATION_MM = 32;
    //  * Small gap around interpretation.
    const INTERPRETATION_MARGIN_MM = 3;

    //  * TEST NAME HELPERS

    const getTestName = (test) => test?.testName?.toLowerCase()?.trim() || "";

    const isFBS = (test) => {
      const name = getTestName(test);

      return (
        name.includes("fasting blood sugar") ||
        name.includes("fasting blood glucose") ||
        name === "fbs"
      );
    };

    const isPPBS = (test) => {
      const name = getTestName(test);

      return (
        name.includes("post prandial blood sugar") ||
        name.includes("postprandial blood sugar") ||
        name.includes("post prandial blood glucose") ||
        name.includes("postprandial blood glucose") ||
        name === "ppbs"
      );
    };

    const isSerumUricAcid = (test) => {
      const name = getTestName(test);
      return name.includes("serum uric acid");
    };

    const isRBS = (test) => {
      const name = getTestName(test);

      return name.includes("random blood sugar") || name === "rbs";
    };
    //  * GET TEST HEIGHT
    const getTestHeight = (test) => {
      let height = NORMAL_TEST_HEIGHT_MM;

      if (isFBS(test)) {
        height += FBS_INTERPRETATION_MM + INTERPRETATION_MARGIN_MM;
      }

      if (isPPBS(test)) {
        height += PPBS_INTERPRETATION_MM + INTERPRETATION_MARGIN_MM;
      }

      if (isSerumUricAcid(test)) {
        height += URIC_ACID_INTERPRETATION_MM + INTERPRETATION_MARGIN_MM;
      }
      if (isRBS(test)) {
        height += RBS_INTERPRETATION_MM + INTERPRETATION_MARGIN_MM;
      }

      return height;
    };

    /*
     * ============================================================
     * PAGE DATA
     * ============================================================
     */

    const pages = [];

    let currentPage = {
      categories: [],
      usedHeight: 0,
    };

    /*
     * ============================================================
     * CREATE NEW PAGE
     * ============================================================
     */

    const pushCurrentPage = () => {
      if (currentPage.categories.length > 0) {
        pages.push(currentPage);
      }

      currentPage = {
        categories: [],
        usedHeight: 0,
      };
    };

    /*
     * ============================================================
     * PROCESS EACH CATEGORY
     * ============================================================
     */

    groupedCategories.forEach(({ categoryName, tests }) => {
      let categoryStarted = false;

      tests.forEach((test, testIndex) => {
        /*
         * ======================================================
         * HEIGHT REQUIRED FOR CATEGORY
         * ======================================================
         */

        const categoryHeight = categoryStarted
          ? 0
          : CATEGORY_HEIGHT_MM + THEAD_HEIGHT_MM;

        /*
         * ======================================================
         * HEIGHT REQUIRED FOR TEST
         * ======================================================
         */

        const testHeight = getTestHeight(test);

        const requiredHeight = categoryHeight + testHeight;

        /*
         * ======================================================
         * CHECK WHETHER TEST FITS
         * ======================================================
         */

        if (
          currentPage.categories.length > 0 &&
          currentPage.usedHeight + requiredHeight > AVAILABLE_HEIGHT_MM
        ) {
          /*
           * Current page is full.
           */
          pushCurrentPage();

          /*
           * Category must be recreated on next page.
           */
          categoryStarted = false;
        }

        /*
         * ======================================================
         * FIND CATEGORY
         * ======================================================
         */

        let currentCategory = currentPage.categories.find(
          (item) => item.categoryName === categoryName,
        );

        /*
         * ======================================================
         * CREATE CATEGORY
         * ======================================================
         */

        if (!currentCategory) {
          currentCategory = {
            categoryName,
            tests: [],

            continuation: testIndex > 0 || pages.length > 0,
          };

          currentPage.categories.push(currentCategory);

          /*
           * Reserve category heading + table header.
           */
          currentPage.usedHeight += CATEGORY_HEIGHT_MM + THEAD_HEIGHT_MM;

          categoryStarted = true;
        }

        /*
         * ======================================================
         * ADD TEST
         * ======================================================
         */

        currentCategory.tests.push(test);

        currentPage.usedHeight += testHeight;

        /*
         * ======================================================
         * IMPORTANT
         * ======================================================
         *
         * If this test has a large interpretation, don't
         * immediately try to squeeze another test after it.
         *
         * This is what prevents FBS/PPBS from causing the
         * browser to create an extra physical PDF page.
         */

        if (
          isFBS(test) ||
          isPPBS(test) ||
          isSerumUricAcid(test) ||
          isRBS(test)
        ) {
          /*
           * If there are more tests in this category and the
           * remaining space is small, start a new React page.
           */

          const remainingHeight = AVAILABLE_HEIGHT_MM - currentPage.usedHeight;

          if (remainingHeight < NORMAL_TEST_HEIGHT_MM + 4) {
            pushCurrentPage();

            categoryStarted = false;
          }
        }
      });
    });

    /*
     * ============================================================
     * ADD LAST PAGE
     * ============================================================
     */

    if (currentPage.categories.length > 0) {
      pages.push(currentPage);
    }

    /*
     * ============================================================
     * SAVE
     * ============================================================
     */

    setIndividualTestPages(pages);
    setIndividualPaginationReady(true);
  }, [groupIndividualTestsByCategory]);

  useEffect(() => {
    if (!newLabReport) {
      setIndividualTestPages([]);
      return;
    }

    setIndividualPaginationReady(false);

    createIndividualTestPages();
  }, [newLabReport, createIndividualTestPages]);

  const profileSampleTypeString = profileSampleTypes.join(", ");
  const hasProfiles = (newLabReport?.profiles || []).length > 0;

  const [pdfHeader, setPdfHeader] = useState(null);
  const [isoLogo, setIsoLogo] = useState(null);
  const [watermarkImg, setWatermarkImg] = useState(null);
  const [nablLogo, setNablLogo] = useState(null);
  const [physicianSign, setPhysicianSign] = useState(null);

  const physicianMeta = useMemo(() => {
    const physician = newLabReport?.assignedPhysician;

    const signature = physician?.signature || physician?.userId?.signature;

    const name =
      newLabReport?.assignedPhysicianName ||
      physician?.userId?.name ||
      physician?.name ||
      "Physician";
    const licenseNo = physician?.license || "";

    const specialization =
      physician?.specialization
        ?.map((spec) => spec.specialization)
        .filter(Boolean)
        .join(", ") || "";

    return {
      signature,
      name,
      specialization,
      physician,
      licenseNo,
    };
  }, [newLabReport]);

  const toBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(
        `${url}${url.includes("?") ? "&" : "?"}t=${new Date().getTime()}`,
        { mode: "cors", cache: "no-store" },
      );
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const loadImages = async () => {
      const info = clinic?.hospitalInfo;

      if (info?.pdfHeader) {
        const header = await toBase64(info.pdfHeader);
        setPdfHeader(header);
      }

      if (info?.ISOLogo) {
        const iso = await toBase64(info.ISOLogo);
        setIsoLogo(iso);
      }
      if (info?.NABLLogo) {
        const nabl = await toBase64(info.NABLLogo);
        setNablLogo(nabl);
      }

      if (info?.waterMark) {
        const watermark = await toBase64(info.waterMark);
        setWatermarkImg(watermark);
      }

      let physicianSignature = physicianMeta.signature;

      if (
        !physicianSignature &&
        physicianMeta.physician &&
        typeof physicianMeta.physician === "string"
      ) {
        try {
          const resultAction = await dispatch(
            getPhysicianById({
              userId: physicianMeta.physician,
              token,
            }),
          );

          if (getPhysicianById.fulfilled.match(resultAction)) {
            const physicianData = resultAction.payload?.result?.list;
            physicianSignature =
              physicianData?.signature ||
              physicianData?.userId?.signature ||
              null;
          }
        } catch (error) {
          console.error("Error fetching physician details:", error);
        }
      }

      if (physicianSignature) {
        const signature = await toBase64(physicianSignature);
        setPhysicianSign(signature);
      }
    };

    loadImages();
  }, [clinic, physicianMeta, token, dispatch]);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `labreport_${newLabReport?.patientId?.UHID || "pt"}`,
  });

  const PageBaseLayout = ({
    showSampleType = false,
    currentSampleType = "",
  }) => (
    <>
      {watermarkImg && (
        <img
          src={watermarkImg}
          alt="WM"
          className={s.watermarkImg}
          style={{ opacity: 0.25, zIndex: 0 }}
          crossOrigin="anonymous"
        />
      )}
      <div className={s.headerSection}>
        <div className={s.headerLeft}>
          {pdfHeader && (
            <img
              src={pdfHeader}
              alt="Logo"
              className={s.labLogo}
              crossOrigin="anonymous"
            />
          )}
          <div className={s.addressText}>
            <strong>{clinic?.clinicName || "SimpleeKare Health"}</strong> <br />
            {clinic?.clinicAddress?.plot && `${clinic.clinicAddress.plot}, `}
            {clinic?.clinicAddress?.area && `${clinic.clinicAddress.area}, `}
            {clinic?.clinicAddress?.city?.name &&
              `${clinic.clinicAddress.city.name}, `}
            {clinic?.clinicAddress?.state?.name &&
              clinic.clinicAddress.state.name}
            {clinic?.clinicAddress?.pin && ` ${clinic.clinicAddress.pin}`}
            <br />
            Contact No : {clinic?.phone || "+91-XXXXXXXXXX"}
            {clinic?.alternateClinicPhone ? (
              <>
                <span> / {clinic.alternateClinicPhone}</span>
              </>
            ) : null}
          </div>
        </div>
        <div className={s.headerRight}>
          <div className={s.trustedWrapper}>
            {isoLogo && (
              <img
                src={isoLogo}
                alt="ISO"
                className={s.trustedLogo}
                crossOrigin="anonymous"
              />
            )}
            {/* <div className={s.trustedText}>
              <p className={s.trustedTitle}>Most Trusted Brand</p>
              <div className={s.statBlock}>
                <span className={s.trustedBold}>40 lakhs+ </span>
                <span className={s.subText}>satisfied customers</span>
              </div>
              <div className={s.statBlock}>
                <span className={s.trustedBold}>1 crore+</span>
                <span className={s.subText}>lab tests booked</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className={s.blackline}></div>
      <div className={s.barcodeRow}>
        <Barcode
          value={newLabReport?.appointmentId || "N/A"}
          height={28}
          width={1.4}
          fontSize={10}
          displayValue={false}
        />
      </div>

      <div className={s.patientDetailsGrid}>
        <table className={s.patientTable}>
          <tbody>
            <tr>
              <td className={s.label}>Name</td>
              <td>: {newLabReport?.patientId?.userId?.name || "-"}</td>
              <td className={s.label}>Client Name</td>
              <td>: {newLabReport?.clientName || " "}</td>
            </tr>
            <tr>
              <td className={s.label}>Age/Gender</td>
              <td>
                : {newLabReport?.patientId?.userId?.age?.year || "-"} Yrs /{" "}
                {newLabReport?.patientId?.userId?.gender || "-"}
              </td>
              <td className={s.label}>Registration Date</td>
              <td>
                :{" "}
                {newLabReport?.createdAt
                  ? new Date(newLabReport.createdAt).toLocaleString("en-GB")
                  : "-"}{" "}
              </td>
            </tr>
            <tr>
              <td className={s.label}>UHID No </td>
              <td>: {newLabReport?.patientId?.UHID || "-"} </td>
              <td className={s.label}>Collection Date</td>
              <td>
                :{" "}
                {newLabReport?.collectionDate
                  ? `${new Date(newLabReport.collectionDate).toLocaleDateString("en-GB")} ${newLabReport?.collectionTime || ""}`
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className={s.label}>Referred By</td>
              <td>: {newLabReport?.referredByName || "Self"} </td>
              <td className={s.label}>Sample Received Date</td>
              <td>
                :{" "}
                {newLabReport?.receivedDate
                  ? `${new Date(newLabReport.receivedDate).toLocaleDateString("en-GB")} ${newLabReport?.receivedTime || ""}`
                  : "-"}
              </td>
            </tr>

            {showSampleType ? (
              <>
                <tr>
                  <td className={s.label}>Report Status</td>
                  <td>: {newLabReport?.labReportStatus || "Final"}</td>
                  <td className={s.label}>Report Date</td>
                  <td>
                    :{" "}
                    {newLabReport?.updatedAt
                      ? new Date(newLabReport.updatedAt).toLocaleString("en-GB")
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td className={s.label}>Sample Type</td>
                  <td>: {currentSampleType || "-"}</td>
                  <td />
                  <td />
                </tr>
              </>
            ) : (
              <tr>
                <td className={s.label}>Report Status</td>
                <td>: {newLabReport?.labReportStatus || "Final"}</td>
                <td className={s.label}>Report Date</td>
                <td>
                  :{" "}
                  {newLabReport?.updatedAt
                    ? new Date(newLabReport.updatedAt).toLocaleString("en-GB")
                    : "-"}{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );

  const PageFooter = () => (
    <>
      <div className={s.signatureBlock}>
        <div className={s.signatureArea}>
          {physicianSign ? (
            <>
              <img
                src={physicianSign}
                alt="Physician Sign"
                className={s.signImg}
                crossOrigin="anonymous"
              />
              <p className={s.signName}>{physicianMeta.name}</p>
              <p className={s.signTitle}>
                {physicianMeta?.physician?.aboutDoctor}
              </p>
              <p
                className={s.signTitle}
              >{`Reg No : ${physicianMeta.licenseNo}`}</p>
            </>
          ) : (
            <>
              {clinic?.hospitalInfo?.authorizedSignature && (
                <img
                  src={clinic.hospitalInfo.authorizedSignature}
                  alt="Sign"
                  className={s.signImg}
                  crossOrigin="anonymous"
                />
              )}
              <p className={s.signName}>Authorised Signatory</p>
            </>
          )}
        </div>
      </div>
      <div className={s.reportFooter}>
        <div className={s.footerLeft}>
          <img
            src={qrcode}
            alt="QR"
            className={s.footerQr}
            crossOrigin="anonymous"
          />
        </div>
        {/* <div className={s.footerCenter}>
          <div className={s.billedByContainer}>
            <p className={s.billedByText}>Billed By : SimpleeKare Health</p>
          </div>
        </div> */}
        <div className={s.footerRight} />
      </div>
    </>
  );

  const handleWhatsapp = () => {
    const phone = newLabReport?.patientId?.userId?.phone || "";
    setMobile(phone);
    setShowWhatsapp(true);
  };

  const generatePdfBlob = async () => {
    await document.fonts.ready;

    const waitForImages = async (element) => {
      const images = Array.from(element.querySelectorAll("img"));

      await Promise.all(
        images.map((img) => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalWidth !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          });
        }),
      );
    };

    await waitForImages(componentRef.current);
    await new Promise((resolve) => setTimeout(resolve, 1500));

    const options = {
      margin: 0,
      filename: "LabReport.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#fff",
        imageTimeout: 0,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
      pagebreak: {
        mode: ["css"],
      },
    };

    return await html2pdf()
      .from(componentRef.current)
      .set(options)
      .outputPdf("blob");
  };

  const sendWhatsapp = async () => {
    const blob = await generatePdfBlob();

    const formData = new FormData();

    const file = new File([blob], "LabReport.pdf", {
      type: "application/pdf",
    });

    formData.append("mobile", mobile);
    formData.append("reportId", newLabReport._id);
    formData.append("patientName", newLabReport?.patientId?.userId?.name || "");
    formData.append("pdf", file);
    dispatch(sendWhatsappReport(formData));

    setShowWhatsapp(false);
    setShowMobileInput(false);
  };

  const handleMail = () => {
    const patientEmail = newLabReport?.patientId?.userId?.email || "";
    setEmail(patientEmail);

    setShowEmail(true);
  };
  const sendMail = async () => {
    const blob = await generatePdfBlob();
    const formData = new FormData();

    const file = new File([blob], "LabReport.pdf", {
      type: "application/pdf",
    });

    formData.append("email", email);
    formData.append("patientName", newLabReport?.patientId?.userId?.name || "");
    formData.append("reportId", newLabReport?._id);
    formData.append("pdf", file);
    formData.append("clinicName", newLabReport?.clinicId?.clinicName || "");
    formData.append(
      "supportPhone",
      newLabReport?.clinicId?.hospitalInfo?.supportPhone || "",
    );
    formData.append(
      "supportEmail",
      newLabReport?.clinicId?.hospitalInfo?.supportEmail || "",
    );

    dispatch(sendLabReportMail(formData));

    setShowEmail(false);
    setShowEmailInput(false);
  };

  useEffect(() => {
    if (whatsappSuccessMessage) {
      showToastifySuccess(whatsappSuccessMessage);
      dispatch(resetWhatsappMessage());
    }
    if (whatsappErrorMessage) {
      showToastifyError(whatsappErrorMessage);
      dispatch(resetWhatsappMessage());
    }
    if (emailSuccessMessage) {
      showToastifySuccess(emailSuccessMessage);
      dispatch(resetEmailMessage());
    }
    if (emailErrorMessage) {
      showToastifyError(emailErrorMessage);
      dispatch(resetEmailMessage());
    }
  }, [
    whatsappSuccessMessage,
    whatsappErrorMessage,
    emailSuccessMessage,
    emailErrorMessage,
  ]);

  return (
    <div className={s.mainWrapper}>
      {/* First Modal to confirm Mobile number and send popup for whatsapp */}
      <Modal show={showWhatsapp} onHide={() => setShowWhatsapp(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Report</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Is this patient's WhatsApp number correct?</p>

          <h4>{mobile}</h4>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowWhatsapp(false);
              setShowMobileInput(true);
            }}
          >
            Change Number
          </button>

          <button className="btn btn-success" onClick={sendWhatsapp}>
            Yes, Send
          </button>
        </Modal.Footer>
      </Modal>
      {/* // end of poppup for whatsapp */}
      {/* Second Modal For Mobile Input */}
      <Modal
        show={showMobileInput}
        onHide={() => setShowMobileInput(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter WhatsApp Number</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
            type="text"
            className="form-control"
            value={mobile}
            maxLength={10}
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
            placeholder="Enter Mobile Number"
          />
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowMobileInput(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={sendWhatsapp}
            disabled={mobile.length !== 10}
          >
            Send Report
          </button>
        </Modal.Footer>
      </Modal>
      {/* End of Second Modal for Mobile input */}
      {/* First Modal to confirm Email and send popup for mail */}
      <Modal show={showEmail} onHide={() => setShowEmail(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Report by Email</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Is this patient's email address correct?</p>

          <h5>{email}</h5>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowEmail(false);
              setShowEmailInput(true);
            }}
          >
            Change Email
          </button>

          <button className="btn btn-success" onClick={sendMail}>
            Yes, Send
          </button>
        </Modal.Footer>
      </Modal>
      {/* End of First Modal for Email input */}
      {/* Second Modal For Email Input */}
      <Modal
        show={showEmailInput}
        onHide={() => setShowEmailInput(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter Email Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email Address"
          />
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowEmailInput(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={sendMail}
            disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
          >
            Send Report
          </button>
        </Modal.Footer>
      </Modal>
      {/* End of Second Modal for Email input */}
      <div className={`${s.actionBar} no-print`}>
        <button className={s.btnDownload} onClick={handlePrint}>
          Download Full Report
        </button>
        <button
          className={s.btnWhatsapp}
          onClick={handleWhatsapp}
          alt="whatsapp"
        >
          <FaWhatsapp />
        </button>
        <button className={s.btnMail} onClick={handleMail} alt="Mail">
          <FaMailBulk />
        </button>
        <button
          className="btn btn-sm btn-primary px-3 py-2 d-flex align-items-center gap-2"
          onClick={goBack}
        >
          <FaArrowLeft />
          Goto lab Report
        </button>
      </div>
      <div ref={componentRef}>
        {/* ============================================================
    INDIVIDUAL TESTS
    CATEGORY-WISE
    DYNAMIC PAGE-WISE
    ============================================================ */}

        {individualPaginationReady &&
          individualTestPages?.length > 0 &&
          individualTestPages?.map((page, pageIndex) => (
            <div
              key={`individual-page-${pageIndex}`}
              className={s.reportPage}
              style={{
                pageBreakAfter: "always",
                breakAfter: "page",
                breakInside: "avoid",
              }}
            >
              {/* ======================================================
          HEADER
          ====================================================== */}

              <PageBaseLayout showSampleType={false} />

              {/* ======================================================
          INDIVIDUAL TEST CONTENT
          ====================================================== */}

              <div className={s.individualTestsContent}>
                {/* ======================================================
            ONE TABLE FOR THE ENTIRE PAGE
            ====================================================== */}

                <table className={s.resultsTable}>
                  {/* ==================================================
              THEAD - ONLY ONCE PER PDF PAGE
              ================================================== */}

                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "40%",
                        }}
                      >
                        Test Description
                      </th>

                      <th
                        style={{
                          textAlign: "center",
                        }}
                      >
                        Value(s)
                      </th>

                      <th
                        style={{
                          textAlign: "center",
                        }}
                      >
                        Unit(s)
                      </th>

                      <th
                        style={{
                          textAlign: "center",
                        }}
                      >
                        Reference Range
                      </th>

                      <th
                        style={{
                          textAlign: "center",
                          width: "10%",
                        }}
                      >
                        NABL Authorized
                      </th>
                    </tr>
                  </thead>

                  {/* ==================================================
              ALL CATEGORIES FOR THIS PAGE
              ================================================== */}

                  <tbody>
                    {page?.categories?.map((category, categoryIndex) => (
                      <React.Fragment
                        key={`individual-category-${pageIndex}-${categoryIndex}`}
                      >
                        {/* CATEGORY HEADING */}
                        <tr className={s.individualCategoryRow}>
                          <td colSpan={5} className={s.testCategoryHeader}>
                            {category?.categoryName.toUpperCase()}
                            {category?.continuation && " (CONT.)"}
                          </td>
                        </tr>

                        {/* TESTS */}
                        {category?.tests?.map((t, idx) => {
                          const testName =
                            t?.testName?.toLowerCase()?.trim() || "";

                          const isSerumUricAcid =
                            testName.includes("serum uric acid");

                          const isFBS =
                            testName.includes("fasting blood sugar") ||
                            testName.includes("fasting blood glucose") ||
                            testName === "fbs";

                          const isPPBS =
                            testName.includes("post prandial blood sugar") ||
                            testName.includes("postprandial blood sugar") ||
                            testName.includes("post prandial blood glucose") ||
                            testName.includes("postprandial blood glucose") ||
                            testName === "ppbs";

                          const isRBS =
                            testName.includes("random blood sugar") ||
                            testName === "rbs";
                            
                          const isAboGroupTest = 
                          testName.includes("abo group & rh type",) ||
                          testName.includes("ABO GROUP & RH TYPE(Blood Group)",);
                          return (
                            <React.Fragment
                              key={`individual-test-${pageIndex}-${categoryIndex}-${idx}`}
                            >
                              {/* ==============================
                TEST ROW
                ============================== */}

                              <tr className={s.individualTestRow}>
                                {/* YOUR EXISTING TEST DESCRIPTION */}
                                <td style={{ borderBottom: "none" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      color: "#4d4dcf",
                                    }}
                                  >
                                    <strong>{t?.testName}</strong>

                                    {t.testMethod && (
                                      <span
                                        style={{
                                          fontSize: "8px",
                                          color: "#666",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        ({t?.testMethod?.name})
                                      </span>
                                    )}
                                  </div>

                                  {t.testSampleType && (
                                    <div
                                      style={{
                                        fontSize: "8.5px",
                                        color: "#A4A0AF",
                                        marginTop: "2px",
                                      }}
                                    >
                                      Sample Type - {t?.testSampleType?.name}
                                    </div>
                                  )}
                                </td>

                                {/* VALUE */}
                                <td
                                  align="center"
                                  style={{
                                    borderBottom: "none",
                                    ...getStatusStyle(
                                      t.value,
                                      (() => {
                                        const age =
                                          newLabReport?.patientId?.userId?.age
                                            ?.year || 0;

                                        const gender =
                                          newLabReport?.patientId?.userId?.gender?.toLowerCase();

                                        if (
                                          age < 10 &&
                                          t?.ilow_range &&
                                          t?.ihigh_range
                                        ) {
                                          return `${t?.ilow_range} - ${t?.ihigh_range}`;
                                        }

                                        if (
                                          age >= 10 &&
                                          gender === "male" &&
                                          t?.mlow_range &&
                                          t?.mhigh_range
                                        ) {
                                          return `${t?.mlow_range} - ${t?.mhigh_range}`;
                                        }

                                        if (
                                          age >= 10 &&
                                          gender === "female" &&
                                          t?.flow_range &&
                                          t?.fhigh_range
                                        ) {
                                          return `${t?.flow_range} - ${t?.fhigh_range}`;
                                        }

                                        if (t?.low_range && t?.high_range) {
                                          return `${t?.low_range} - ${t?.high_range}`;
                                        }

                                        return (
                                          t?.reference_range_details || "N/A"
                                        );
                                      })(),
                                    ),
                                  }}
                                >
                                  {isAboGroupTest ? (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <span>{t?.value || "-"}</span>

                                      {t?.rhType && <span>{t.rhType}</span>}
                                    </span>
                                  ) : (
                                    t?.value || "-"
                                  )}
                                  {/* {t?.value || "-"} */}
                                </td>

                                {/* UNIT */}
                                <td
                                  align="center"
                                  style={{
                                    borderBottom: "none",
                                  }}
                                >
                                  {t?.units || "-"}
                                </td>

                                {/* REFERENCE RANGE */}
                                <td
                                  align="center"
                                  style={{
                                    borderBottom: "none",
                                  }}
                                >
                                  {(() => {
                                    const age =
                                      newLabReport?.patientId?.userId?.age
                                        ?.year || 0;

                                    const gender =
                                      newLabReport?.patientId?.userId?.gender?.toLowerCase();

                                    if (
                                      age < 10 &&
                                      t?.ilow_range &&
                                      t?.ihigh_range
                                    ) {
                                      return `${t?.ilow_range} - ${t?.ihigh_range}`;
                                    }

                                    if (
                                      age >= 10 &&
                                      gender === "male" &&
                                      t?.mlow_range &&
                                      t?.mhigh_range
                                    ) {
                                      return `${t?.mlow_range} - ${t?.mhigh_range}`;
                                    }

                                    if (
                                      age >= 10 &&
                                      gender === "female" &&
                                      t?.flow_range &&
                                      t?.fhigh_range
                                    ) {
                                      return `${t?.flow_range} - ${t?.fhigh_range}`;
                                    }

                                    if (t?.low_range && t?.high_range) {
                                      return `${t?.low_range} - ${t?.high_range}`;
                                    }

                                    return t?.reference_range_details || "N/A";
                                  })()}
                                </td>

                                {/* NABL */}
                                <td
                                  align="center"
                                  style={{
                                    borderBottom: "none",
                                  }}
                                >
                                  {t?.isNABL === "Yes" && nablLogo ? (
                                    <img
                                      src={nablLogo}
                                      alt="NABL Approved"
                                      title="NABL Approved"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>

                              {/* ==================================================
                SERUM URIC ACID INTERPRETATION
                SHOW IMMEDIATELY AFTER THIS TEST
                ================================================== */}

                              {isSerumUricAcid && (
                                <tr className={s.interpretationRow}>
                                  <td colSpan={5}>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        pageBreakInside: "avoid",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          marginBottom: "8px",
                                          color: "#111827",
                                        }}
                                      >
                                        Interpretation
                                      </div>

                                      <ul
                                        style={{
                                          margin: "0 0 0 20px",
                                          padding: 0,
                                          fontSize: "11px",
                                          lineHeight: "1.7",
                                          color: "#374151",
                                          listStyleType: "disc",
                                          listStylePosition: "outside",
                                        }}
                                      >
                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Serum uric acid level reflects the
                                          balance between its production (from
                                          purine metabolism) and excretion
                                          (mainly via the kidneys).
                                        </li>

                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Increased uric acid (Hyperuricemia)
                                          may be associated with gout, renal
                                          impairment, increased cell turnover
                                          (as in leukemia, lymphoma, or during
                                          chemotherapy), metabolic syndrome, or
                                          excessive dietary intake of
                                          purine-rich foods and alcohol.
                                        </li>

                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Decreased uric acid (Hypouricemia) may
                                          occur in renal tubular dysfunction.
                                          Clinical correlation with symptoms
                                          (e.g., joint pain/swelling in gout)
                                          and renal function is recommended.
                                        </li>

                                        <li>
                                          Persistent abnormalities should be
                                          evaluated further for underlying
                                          metabolic or renal disorders.
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              )}

                              {/* ==================================================
                FBS INTERPRETATION
                SHOW IMMEDIATELY AFTER THIS TEST
                ================================================== */}

                              {isFBS && (
                                <tr className={s.interpretationRow}>
                                  <td colSpan={5}>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        pageBreakInside: "avoid",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          marginBottom: "8px",
                                          color: "#111827",
                                        }}
                                      >
                                        Interpretation
                                      </div>

                                      <ul
                                        style={{
                                          margin: "0 0 0 20px",
                                          padding: 0,
                                          fontSize: "11px",
                                          lineHeight: "1.7",
                                          color: "#374151",
                                          listStyleType: "disc",
                                          listStylePosition: "outside",
                                        }}
                                      >
                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Fasting blood glucose levels reflect
                                          the body’s ability to regulate blood
                                          sugar after an overnight fast.
                                        </li>

                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Normal range: 70–110 mg/dL
                                        </li>

                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          Impaired fasting glucose
                                          (Prediabetes): 100–125 mg/dL
                                        </li>

                                        <li>
                                          Diabetes mellitus (suggestive): ≥126
                                          mg/dL on more than one occasion.
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              )}

                              {/* ==================================================
    PPBS INTERPRETATION
    SHOW IMMEDIATELY AFTER THIS TEST
    ================================================== */}

                              {isPPBS && (
                                <tr className={s.interpretationRow}>
                                  <td colSpan={5}>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        pageBreakInside: "avoid",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          marginBottom: "8px",
                                          color: "#111827",
                                        }}
                                      >
                                        Interpretation
                                      </div>

                                      <ul
                                        style={{
                                          margin: "0 0 0 20px",
                                          padding: 0,
                                          fontSize: "11px",
                                          lineHeight: "1.7",
                                          color: "#374151",
                                          listStyleType: "disc",
                                          listStylePosition: "outside",
                                        }}
                                      >
                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          {" "}
                                          <span
                                            style={{
                                              position: "absolute",
                                              left: 10,
                                            }}
                                          >
                                            •{" "}
                                          </span>
                                          Post Prandial Blood Sugar (PPBS)
                                          measures blood glucose levels 2 hours
                                          after a meal and helps assess glucose
                                          metabolism and diabetes control Normal
                                          PPBS level: Less than 110 mg/dL.
                                        </li>

                                        <li style={{ marginBottom: "6px" }}>
                                          PPBS values between 70–140 mg/dL may
                                          indicate impaired glucose tolerance
                                          (Prediabetes)
                                        </li>
                                        <li style={{ marginBottom: "6px" }}>
                                          <span
                                            style={{
                                              position: "absolute",
                                              left: 10,
                                            }}
                                          >
                                            •{" "}
                                          </span>
                                          PPBS value ?200 mg/dL may be
                                          suggestive of Diabetes Mellitus and
                                          should be correlated with FBS and
                                          HbA1c for confirmation
                                        </li>
                                        <li>
                                          Persistent elevated PPBS levels
                                          require lifestyle modification,
                                          dietary control, regular exercise, and
                                          medical follow-up.
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              )}

                              {/* RBS INTERPRETATION */}
                              {isRBS && (
                                <tr className={s.interpretationRow}>
                                  <td colSpan={5}>
                                    <div
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        pageBreakInside: "avoid",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          fontWeight: "700",
                                          marginBottom: "8px",
                                          color: "#111827",
                                        }}
                                      >
                                        Interpretation:
                                      </div>

                                      <ul
                                        style={{
                                          margin: "0 0 0 20px",
                                          padding: 0,
                                          fontSize: "11px",
                                          lineHeight: "1.7",
                                          color: "#374151",
                                          listStyleType: "disc",
                                          listStylePosition: "outside",
                                        }}
                                      >
                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              position: "absolute",
                                              left: 10,
                                            }}
                                          >
                                            •{" "}
                                          </span>
                                          An elevated RBS value may indicate
                                          impaired glucose tolerance or diabetes
                                          mellitus and should be correlated with
                                          fastin plasma glucose,postprandial
                                          glucose, and HbA1c levels for
                                          confirmation.
                                        </li>
                                        <li
                                          style={{
                                            marginBottom: "6px",
                                          }}
                                        >
                                          {" "}
                                          <span
                                            style={{
                                              position: "absolute",
                                              left: 10,
                                            }}
                                          >
                                            •{" "}
                                          </span>
                                          Low RBS values (70 mg/dL) may Suggest
                                          hypoglycemia,which can occur due to
                                          prolonged fastin,excessive insulin, or
                                          certain medication.
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>

              {pageIndex === individualTestPages.length - 1 && !hasProfiles && (
                <div className={s.endOfReport}>*** END OF REPORT ***</div>
              )}
              {/* ======================================================
          FOOTER
          ====================================================== */}

              <PageFooter />
            </div>
          ))}

        {/* DETAILED PROFILES SECTION */}
        {detailedProfiles.map((profile, pIdx) => {
          const pName = profile.profileName?.toLowerCase() || "";

          const isSpecial =
            pName.includes("culture") ||
            pName.includes("sensitivity") ||
            pName.includes("pus") ||
            pName.includes("e/t tube") ||
            pName.includes("urine r/m") ||
            pName.includes("urine routine") ||
            pName.includes("stool r/m") ||
            pName.includes("stool routine") ||
            pName === "dengue profile" ||
            pName.includes("rapid") ||
            pName.includes("typhoid") ||
            pName.includes("synovial") ||
            pName.includes("peripheral smear") ||
            pName.includes("ps comment") ||
            pName.includes("p.s. comment") ||
            pName.includes("malaria") ||
            pName.includes("mp ict") ||
            pName.includes("mp(ict)") ||
            pName.includes("seminal") ||
            pName.includes("semen analysis") ||
            pName.includes("cbc") ||
            pName.includes("complete blood") ||
            pName.includes("complete blood count") ||
            pName.includes("fnac") ||
            pName.includes("widal");

          const isLFT =
            pName.includes("liver function test") || pName.includes("lft");
          const isLipid = pName.includes("lipid profile");

          const getProfileTestValue = (names) => {
            const aliases = Array.isArray(names) ? names : [names];
            const test = profile.tests?.find((t) => {
              const testName = t.testName?.toLowerCase()?.trim();
              return aliases.some(
                (name) => testName === name.toLowerCase().trim(),
              );
            });
            return Number(test?.value) || 0;
          };

          const totalBilirubin = getProfileTestValue(["bilirubin total"]);
          const directBilirubin = getProfileTestValue(["bilirubin direct"]);
          const indirectBilirubin =
            !Number.isNaN(totalBilirubin) && !Number.isNaN(directBilirubin)
              ? (totalBilirubin - directBilirubin).toFixed(2)
              : "";

          const totalProtein = getProfileTestValue(["total protein"]);
          const albumin = getProfileTestValue(["albumin(alb)", "albumin"]);
          const globulinValue =
            !Number.isNaN(totalProtein) && !Number.isNaN(albumin)
              ? (totalProtein - albumin).toFixed(2)
              : "";

          const albGlbRatio = (() => {
            if (
              Number.isNaN(Number(albumin)) ||
              Number.isNaN(Number(globulinValue)) ||
              Number(globulinValue) === 0
            )
              return "";
            const ratio = Number(albumin) / Number(globulinValue);
            return isFinite(ratio) ? ratio.toFixed(2) : "";
          })();

          const cholesterol = getProfileTestValue(["cholesterol"]);
          const hdl = getProfileTestValue(["hdl"]);
          const tg = getProfileTestValue([
            "triglycerides(tg)",
            "triglycerides",
            "triglycerides (tg)",
          ]);

          const vldlValue = !Number.isNaN(tg) ? (tg / 5).toFixed(2) : "";
          const ldlValue =
            !Number.isNaN(cholesterol) &&
            !Number.isNaN(hdl) &&
            !Number.isNaN(tg)
              ? (cholesterol - hdl - tg / 5).toFixed(2)
              : "";
          const cholHdlRatio =
            !Number.isNaN(hdl) && hdl !== 0 && !Number.isNaN(cholesterol)
              ? (cholesterol / hdl).toFixed(2)
              : "";
          const ldlHdlRatio =
            !Number.isNaN(hdl) &&
            hdl !== 0 &&
            ldlValue !== "" &&
            !Number.isNaN(Number(ldlValue))
              ? (Number(ldlValue) / hdl).toFixed(2)
              : "";

          const hasHbA1c = (profile.tests || []).some((item) => {
            const testName = item.testName?.toLowerCase()?.trim() || "";
            return (
              testName.includes("hba1c") ||
              testName.includes("hemoglobin a1c") ||
              testName.includes("haemoglobin a1c")
            );
          });

          const isHba1c =
            pName.includes("hba1c") ||
            pName.includes("glycated hemoglobin") ||
            hasHbA1c;

          const hba1cTest = profile.tests?.find((t) => {
            const testName = t.testName?.toLowerCase()?.trim() || "";
            const isAbg =
              testName.includes("abg") ||
              testName.includes("average blood glucose");
            return (
              !isAbg &&
              (testName === "hba1c" ||
                testName.includes("hba1c") ||
                testName.includes("hemoglobin a1c") ||
                testName.includes("haemoglobin a1c"))
            );
          });
          const hba1cVal = parseFloat(hba1cTest?.value);
          const abgValue =
            !isNaN(hba1cVal) && hba1cVal > 0
              ? (28.7 * hba1cVal - 46.7).toFixed(2)
              : "";

          const getCalculatedValue = (subTest) => {
            const testName = subTest.testName?.toLowerCase()?.trim();
            if (isLFT) {
              if (testName === "bilirubin indirect") return indirectBilirubin;
              if (testName === "globulin") return globulinValue;
              if (testName === "alb/glb ratio") return albGlbRatio;
            }
            if (isLipid) {
              if (testName === "ldl") return ldlValue;
              if (testName === "vldl") return vldlValue;
              if (
                testName === "chol/hdl ratio" ||
                testName === "chol hdl ratio"
              )
                return cholHdlRatio;
              if (testName === "ldl/hdl ratio" || testName === "ldl hdl ratio")
                return ldlHdlRatio;
            }
            if (isHba1c) {
              if (
                testName === "abg" ||
                testName.includes("abg") ||
                testName.includes("average blood glucose")
              ) {
                return abgValue || subTest.value;
              }
            }
            return subTest.value;
          };

          const hasRFT =
            pName.includes("rft") ||
            pName.includes("renal function test") ||
            pName.includes("renal profile");

          const hasLFT =
            pName.includes("lft") ||
            pName.includes("liver function test") ||
            pName.includes("liver profile");

          const hasLipidProfile =
            pName.includes("lipid") ||
            pName.includes("lipid profile") ||
            pName.includes("cholesterol profile");

          const hasKFT =
            pName.includes("kft") ||
            pName.includes("kidney function test") ||
            pName.includes("kidney profile");

          if (isSpecial) {
            let SpecialComp = null;
            if (
              pName.includes("culture") ||
              pName.includes("sensitivity") ||
              pName.includes("pus") ||
              pName.includes("e/t tube")
            )
              SpecialComp = (
                <CultureReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("urine"))
              SpecialComp = (
                <UrineReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("stool"))
              SpecialComp = (
                <StoolReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName === "dengue profile")
              SpecialComp = (
                <DengueReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("rapid"))
              SpecialComp = (
                <DengueRapidReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("typhoid"))
              SpecialComp = (
                <TyphoidReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("synovial"))
              SpecialComp = (
                <SynovialFluidAnalysisPdf
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (
              pName.includes("peripheral smear") ||
              pName.includes("ps comment")
            )
              SpecialComp = (
                <PeripheralSmearReport
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (
              pName.includes("cbc") ||
              pName.includes("complete blood") ||
              pName.includes("complete blood count")
            )
              SpecialComp = (
                <CBCReport
                  profile={profile}
                  patientData={newLabReport?.patientId}
                  userData={newLabReport?.patientId?.userId}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                  NABLLOGO={nablLogo}
                />
              );
            else if (pName.includes("malaria") || pName.includes("mp"))
              SpecialComp = (
                <MalariaParasiteICT
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("seminal") || pName.includes("semen"))
              SpecialComp = (
                <SeminalFluidAnalysisPdf
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("fnac"))
              SpecialComp = (
                <FnacReportPdf
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );
            else if (pName.includes("widal"))
              SpecialComp = (
                <WidalReportPdf
                  profile={profile}
                  PageBaseLayout={PageBaseLayout}
                  PageFooter={PageFooter}
                />
              );

            return (
              <React.Fragment key={`special-${pIdx}`}>
                {SpecialComp}
              </React.Fragment>
            );
          }

          const testChunks = chunkArray(profile.tests, 14);
          return testChunks.map((chunk, chunkIdx) => (
            <div
              key={`profile-${pIdx}-page-${chunkIdx}`}
              className={s.reportPage}
              style={{ pageBreakAfter: "always" }}
            >
              <PageBaseLayout
                showSampleType={true}
                currentSampleType={profile?.testSampleType?.name}
              />
              <table className={s.resultsTable}>
                {/* ======================================================
      TABLE HEADER
      ====================================================== */}
                <thead>
                  <tr>
                    <th style={{ width: "40%" }}>Test Description</th>

                    <th style={{ textAlign: "center" }}>Value(s)</th>

                    <th style={{ textAlign: "center" }}>Unit(s)</th>

                    <th style={{ textAlign: "center" }}>Reference Range</th>

                    <th
                      style={{
                        textAlign: "center",
                        width: "10%",
                      }}
                    >
                      NABL Authorized
                    </th>
                  </tr>
                </thead>

                {/* ======================================================
      TABLE BODY
      ====================================================== */}
                <tbody>
                  {/* ==================================================
        CATEGORY NAME
        CENTERED
        ================================================== */}
                  <tr className={s.profileCategoryRow}>
                    <td
                      colSpan={5}
                      style={{
                        textAlign: "center",
                        fontSize: "11px",
                        fontWeight: "900",
                        padding: "4px 8px",
                        color: "#4d4dcf",
                        textTransform: "uppercase",
                        borderBottom: "none",
                        // background: "#4fd96d",
                      }}
                    >
                      {profile?.category?.categoryName || "OTHERS"}
                    </td>
                  </tr>

                  {/* ==================================================
        PROFILE NAME
        LEFT ALIGNED
        ================================================== */}
                  <tr className={s.profileNameRow}>
                    <td
                      colSpan={5}
                      style={{
                        textAlign: "left",
                        fontSize: "11px",
                        fontWeight: "700",
                        padding: "4px 8px",
                        background: "#ffffff",
                        color: "#4d4dcf",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {profile?.profileName?.toUpperCase()}

                      {chunkIdx > 0 && " (CONT.)"}
                    </td>
                  </tr>

                  {/* ==================================================
        PROFILE TESTS
        ================================================== */}
                  {chunk.map((subTest, sIdx) => (
                    <tr key={`sub-${sIdx}`}>
                      {/* ==================================================
            TEST DESCRIPTION
            ================================================== */}
                      <td
                        style={{
                          borderBottom: "none",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* Test Name */}
                          <strong>{subTest.testName}</strong>

                          {/* Method */}
                          {subTest?.testMethod && (
                            <span
                              style={{
                                fontSize: "8.5px",
                                color: "#555",
                                fontStyle: "italic",
                                marginTop: "2px",
                              }}
                            >
                              ({subTest.testMethod?.name})
                            </span>
                          )}

                          {/* Sample Type */}
                          {/* {subTest?.testSampleType && (
                            <span
                              style={{
                                fontSize: "8.5px",
                                color: "#A4A0AF",
                                marginTop: "2px",
                              }}
                            >
                              {subTest?.testSampleType?.name}
                            </span>
                          )} */}
                        </div>
                      </td>

                      {/* ==================================================
            VALUE
            ================================================== */}
                      <td
                        align="center"
                        style={{
                          borderBottom: "none",
                          ...getStatusStyle(
                            getCalculatedValue(subTest) || subTest.value,
                            (() => {
                              const age =
                                newLabReport?.patientId?.userId?.age?.year || 0;

                              const gender =
                                newLabReport?.patientId?.userId?.gender?.toLowerCase();

                              // AGE < 10
                              if (
                                age < 10 &&
                                subTest.ilow_range &&
                                subTest.ihigh_range
                              ) {
                                return `${subTest.ilow_range} - ${subTest.ihigh_range}`;
                              }

                              // MALE
                              if (
                                age >= 10 &&
                                gender === "male" &&
                                subTest.mlow_range &&
                                subTest.mhigh_range
                              ) {
                                return `${subTest.mlow_range} - ${subTest.mhigh_range}`;
                              }

                              // FEMALE
                              if (
                                age >= 10 &&
                                gender === "female" &&
                                subTest.flow_range &&
                                subTest.fhigh_range
                              ) {
                                return `${subTest.flow_range} - ${subTest.fhigh_range}`;
                              }

                              // DEFAULT
                              if (subTest.low_range && subTest.high_range) {
                                return `${subTest.low_range} - ${subTest.high_range}`;
                              }

                              return subTest.reference_range_details || "N/A";
                            })(),
                          ),
                        }}
                      >
                        {getCalculatedValue(subTest) || subTest.value || "-"}
                      </td>

                      {/* ==================================================
            UNIT
            ================================================== */}
                      <td
                        align="center"
                        style={{
                          borderBottom: "none",
                        }}
                      >
                        {subTest.units || "-"}
                      </td>

                      {/* ==================================================
            REFERENCE RANGE
            ================================================== */}
                      <td
                        align="center"
                        style={{
                          borderBottom: "none",
                        }}
                      >
                        {(() => {
                          const age =
                            newLabReport?.patientId?.userId?.age?.year || 0;

                          const gender =
                            newLabReport?.patientId?.userId?.gender?.toLowerCase();

                          // AGE < 10
                          if (
                            age < 10 &&
                            subTest.ilow_range &&
                            subTest.ihigh_range
                          ) {
                            return `${subTest.ilow_range} - ${subTest.ihigh_range}`;
                          }

                          // MALE
                          if (
                            age >= 10 &&
                            gender === "male" &&
                            subTest.mlow_range &&
                            subTest.mhigh_range
                          ) {
                            return `${subTest.mlow_range} - ${subTest.mhigh_range}`;
                          }

                          // FEMALE
                          if (
                            age >= 10 &&
                            gender === "female" &&
                            subTest.flow_range &&
                            subTest.fhigh_range
                          ) {
                            return `${subTest.flow_range} - ${subTest.fhigh_range}`;
                          }

                          // DEFAULT
                          if (subTest.low_range && subTest.high_range) {
                            return `${subTest.low_range} - ${subTest.high_range}`;
                          }

                          return subTest.reference_range_details || "N/A";
                        })()}
                      </td>

                      {/* ==================================================
            NABL
            ================================================== */}
                      <td
                        align="center"
                        style={{
                          borderBottom: "none",
                        }}
                      >
                        {subTest?.isNABL === "Yes" ? (
                          <img
                            src={nablLogo}
                            alt="NABL Approved"
                            title="NABL Approved"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {chunkIdx === 0 && hasHbA1c && (
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      lineHeight: "1.6",
                      color: "#374151",
                    }}
                  >
                    Interpretation of HbA1c may be affected by conditions
                    altering red cell turnover (e.g. anemia, hemoglobinopathies,
                    CKD). Correlation with clinical findings and glucose
                    measurements advised.
                  </div>
                </div>
              )}

              {chunkIdx === 0 && hasRFT && (
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <ul
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontSize: "11px",
                      lineHeight: "1.7",
                      color: "#374151",
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Renal function tests assess the kidney's ability to filter
                      and excrete metabolic waste products and maintain fluid
                      and electrolyte balance.
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Serum urea and creatinine are key indicators of glomerular
                      function, while electrolytes help evaluate tubular and
                      overall renal performance.
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Elevated urea and creatinine may indicate impaired renal
                      function due to acute kidney injury, chronic kidney
                      disease, dehydration, or obstruction of urinary outflow.
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      Low urea may be seen in liver dysfunction, low protein
                      intake, or overhydration.
                    </li>
                  </ul>
                </div>
              )}

              {chunkIdx === 0 && hasLFT && (
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontSize: "11px",
                      lineHeight: "1.7",
                      color: "#374151",
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    Liver function tests assess hepatocellular integrity,
                    cholestasis, and synthetic capacity of the liver.
                  </div>
                  <ul
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontSize: "11px",
                      lineHeight: "1.7",
                      color: "#374151",
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Elevated ALT (SGPT) and AST (SGOT): Suggest hepatocellular
                      injury, which may occur in viral hepatitis, drug-induced
                      liver injury, alcohol-related liver disease, or
                      non-alcoholic fatty liver disease.
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Raised Alkaline Phosphatase (ALP): Indicate possible
                      cholestasis or obstruction; GGT elevation supports a
                      hepatic origin of increased ALP.
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      Increased Total and Direct Bilirubin: Reflect impaired
                      bilirubin metabolism or excretion, seen in hepatocellular
                      or obstructive jaundice.
                    </li>
                  </ul>
                </div>
              )}

              {chunkIdx === 0 && hasLipidProfile && (
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <ul
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontSize: "11px",
                      lineHeight: "1.7",
                      color: "#374151",
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      The lipid profile includes assessment of total
                      cholesterol, triglycerides, HDL cholesterol, LDL
                      cholesterol, and VLDL cholesterol, which together help
                      evaluate cardiovascular risk.
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Elevated total cholesterol and LDL levels indicate
                      increased risk of atherosclerosis and coronary heart
                      disease (CHD).
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      Low HDL cholesterol is an independent risk factor for
                      cardiovascular disease.
                    </li>
                    <li style={{ listStyleType: "disc", marginBottom: "6px" }}>
                      High triglycerides may be associated with metabolic
                      syndrome, diabetes mellitus, hypothyroidism, nephrotic
                      syndrome, or excessive alcohol intake.
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      Low total cholesterol or triglycerides may occur in
                      malnutrition, malabsorption, hyperthyroidism, or chronic
                      illness.
                    </li>
                  </ul>
                </div>
              )}
              {chunkIdx === 0 && hasKFT && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    pageBreakInside: "avoid",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "700",
                      marginBottom: "8px",
                      color: "#111827",
                    }}
                  >
                    Interpretation:
                  </div>
                  <ul
                    style={{
                      margin: "0 0 0 10px",
                      fontSize: "11px",
                      lineHeight: "1.7",
                      color: "#374151",
                      listStyleType: "disc",
                      listStylePosition: "outside",
                    }}
                  >
                    <li style={{ marginBottom: "6px" }}>
                      Kidney function tests are urine or blood tests that
                      evaluate how well your kidneys are working. Most of these
                      tests measure glomerular filtration rate (GFR). GFR
                      assesses how efficiently your kidneys clear waste from
                      your system.They help your body filter waste materials and
                      expel them as urine.Your kidneys are also vital for
                      producing:
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {" "}
                      Hormones that maintain blood pressure{" "}
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {" "}
                      Red blood cells, which carry oxygen throughout your
                      body.{" "}
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {" "}
                      Vitamin D, which maintains bone and muscle health.{" "}
                    </li>
                  </ul>
                </div>
              )}

              {pIdx === detailedProfiles.length - 1 &&
                chunkIdx === testChunks.length - 1 && (
                  <div className={s.endOfReport}>*** END OF REPORT ***</div>
                )}

              <PageFooter />
            </div>
          ));
        })}
      </div>
    </div>
  );
};
export default LabReportPDF;
